import { LogIn } from 'lucide-react';

import { useSessionExpiredBanner } from '@/hooks/ui/banners/useSessionExpiredBanner';
import { PageBanner } from './PageBanner';

/**
 * The session-expired strip — ROUTE_INVENTORY Part 1, G7. Tone: destructive
 * (nothing that needs the server works until the user signs in again), and
 * `role='alert'`.
 *
 * `SessionExpiredBannerView` is the strip; `SessionExpiredBanner` wires it to
 * `useSessionExpiredBanner`, standalone. In the app it is shown by
 * `features/shell/ShellBanners`, where it outranks every other strip.
 */
export function SessionExpiredBannerView({
  onSignInAgain,
  onDismiss,
}: {
  onSignInAgain: () => void;
  onDismiss: () => void;
}) {
  return (
    <PageBanner
      tone='destructive'
      icon={LogIn}
      message='Your session has expired.'
      detail='Sign in again to keep working.'
      action={{ label: 'Sign in again', onClick: onSignInAgain }}
      onDismiss={onDismiss}
      dismissLabel='Dismiss session-expired banner'
      live='alert'
    />
  );
}

export function SessionExpiredBanner() {
  const { raised, dismissed, dismiss, signInAgain } = useSessionExpiredBanner();
  if (!raised || dismissed) return null;
  return (
    <SessionExpiredBannerView
      onSignInAgain={() => void signInAgain()}
      onDismiss={dismiss}
    />
  );
}
